export default __webpack_public_path__ + "static/media/location_preview_tv_station.c7645703.svg";